import {
  Loading,
  Table,
  TableCell,
  type TableCellProps,
  TableContainer,
  type TableRowProps,
} from '@shared/components';
import {
  TableBody,
  type TableBodyRow,
  TableHeader,
  type TableHeaderRow,
} from '@shared/table-generator';

import ExamineeMonitorNoRowsOverlay from './examinee-monitor-no-rows-overlay';

interface ExamineeMonitorTableProps {
  rows: TableBodyRow[];
  columns: TableHeaderRow[];
  isLoading?: boolean;
  slotProps?: {
    tableHeaderCell?: TableCellProps;
    tableBodyCell?: TableCellProps;
    tableBodyRow?: TableRowProps;
  };
}

export default function ExamineeMonitorTable(props: Readonly<ExamineeMonitorTableProps>) {
  const { rows, columns, isLoading, slotProps } = props;

  return (
    <TableContainer
      sx={{
        borderRadius: (theme) => theme.shape.rounded(2),
        border: '1px solid',
        borderColor: (theme) => theme.palette.grey[300],
        width: '100%',
      }}
    >
      <Table sx={{ borderCollapse: 'collapse', tableLayout: 'fixed' }}>
        <TableHeader columns={columns} slotProps={slotProps} />
        {isLoading ? (
          <TableCell colSpan={10} sx={(theme) => ({ py: theme.spacing(4), width: '100%' })}>
            <Loading
              sx={{
                width: '100%',
              }}
            />
          </TableCell>
        ) : !rows.length ? (
          <ExamineeMonitorNoRowsOverlay />
        ) : (
          <TableBody rows={rows} slotProps={slotProps} />
        )}
      </Table>
    </TableContainer>
  );
}
